import { Component, OnInit, inject } from "@angular/core";

import { CScrollService } from "../../services/confect-scroll.service";

@Component({
  selector: "confect-main-wrapper",
  templateUrl: "./confect-main-wrapper.component.html",
  standalone: false,
})
export class CMainWrapperComponent implements OnInit {
  cScroll = inject(CScrollService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  ngOnInit(): void {}
}
